import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Gaining control: Exercise</div>
                                            <p>Many of us will have been in a situation where we have
                                                ‘derailed’; that is, where we had control
                                                of a situation and then, for whatever reason, we lost it again.
                                                In this exercise, we will look at how
                                                to prevent yourself from being ‘derailed’ in the future.</p>
                                            <p><span className="subtiltereg">Step 1:</span> Think of a time when
                                                you lost control of a situation. You may have thought you had
                                                everything covered, but things can go off track. Think of the
                                                impact it had on your team, and the
                                                task you were all doing. Remember, we learn more from our
                                                mistakes than our successes. Don’t
                                                beat yourself up about it, but think instead of the insight it
                                                gave you and that it made you aware
                                                of skills you can now develop, as a result.</p>
                                            <p><span className="subtiltereg">Step 2:</span> Discuss the
                                                situation with a mentor or line manager. Using what you’ve read
                                                so far,
                                                identify the locus of control you applied. Was it external,
                                                internal, or half-way between the two?
                                                Identify when it all began to derail. Did you overlook something
                                                in the planning stage? Or did you
                                                assume a level of competence in a team member that they didn’t
                                                have (and which you could now
                                                help them to develop)?</p>
                                            <p><span className="subtiltereg">Step 3:</span> With your line
                                                manager, make a plan of action for your future development. It
                                                might be
                                                helpful to recreate the situation that went off the rails at a
                                                team training event, so that you and
                                                your team can learn from the experience. It can be challenging
                                                to face up to mistakes in front of
                                                others. However, doing so openly and sharing the insights gained
                                                can do much to build trust and
                                                enable you to manage future projects better – and your team will
                                                be clearer about what is
                                                expected of them.</p>

                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading lightbgcenter"
                                                style={{marginBottom:'20px'}}>
                                                <p>Do not overload yourself. Delegate some responsibility to
                                                    others. You can do this whilst
                                                    maintaining overall control and it will enable you to focus
                                                    on the bigger picture while letting
                                                    others feel involved.</p>
                                            </div>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now you’ve read this far, here’s a selection of things you can do
                                                to reinforce what you’ve learned:</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about opportunities at work, or elsewhere, where you can
                                                practise taking control. Are there
                                                projects you can lead? Meetings you can attend? Presentations to
                                                give?</p>
                                            <div className="border_subtitle">Discuss the gaining control
                                                exercise
                                            </div>
                                            <p>Arrange a meeting with someone appropriate to discuss your
                                                reflections, using the Gaining
                                                Control exercise. This could be your mentor, line manager, coach
                                                or a colleague. Ask more than
                                                one person to get different perspectives.</p>
                                            <div className="border_subtitle">Set up an evaluation meeting</div>
                                            <p>Set up a further ‘evaluation meeting’ for a later date to ask
                                                whether your skill in taking control has
                                                noticeably improved or whether there are aspects that still need
                                                development.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Make ‘taking control’ a specific objective and factor this into
                                                your own, personal development
                                                plan. Make sure you give yourself clear tasks and objectives to
                                                ensure measurable improvements.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}